import { render, staticRenderFns } from "./SetDataType.vue?vue&type=template&id=2dba6506"
import script from "./SetDataType.vue?vue&type=script&lang=js"
export * from "./SetDataType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports